module.exports = __webpack_public_path__ + "static/img/badge.09f5554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badge.png
// module id = vyjW
// module chunks = 17